import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect } from "react";
import { BarChart, Brush, Bar, XAxis, Cell, Legend, ResponsiveContainer, LabelList } from "recharts";
import moment from "moment";
import { CustomizedTick, CustomizedLabel } from "../shared";
import * as d3 from "d3";
moment.locale("en", {
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
});

var SingleBarChart = function SingleBarChart(_ref) {
  var groupedBy = _ref.groupedBy,
      data = _ref.data,
      translation = _ref.translation,
      acc = _ref.acc,
      props = _objectWithoutProperties(_ref, ["groupedBy", "data", "translation", "acc"]);

  // console.group("SingleBarChart");
  // // // console.log("translation.chart ", translation);
  // console.log("data", data);
  // console.log("acc", acc);
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      barData = _useState2[0],
      setBarData = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      activeIndex = _useState4[0],
      setActiveIndex = _useState4[1];

  useEffect(function () {
    setBarData(d3.nest().key(function (d) {
      return d.date.replace("-", "").substr(0, 6);
    }).rollup(function (v) {
      return {
        type: v[0].type,
        count: v.length,
        total: +d3.sum(v, function (d) {
          var splitted = acc.split(".");
          return splitted.length === 1 ? d[splitted[0]] : d[splitted[0]][splitted[1]];
        }).toFixed(0) // avg: d3.mean(v, (d) => d[acc]).toFixed(0)

      };
    }).entries(data).sort(function (a, b) {
      if (a.key < b.key) {
        return -1;
      } else if (a.key > b.key) {
        return 1;
      } else return 0;
    }));
  }, [data, acc]);
  return barData && /*#__PURE__*/React.createElement(ResponsiveContainer, {
    height: props.height || 200
  }, /*#__PURE__*/React.createElement(BarChart, {
    width: 600,
    height: props.height || 200,
    data: barData,
    margin: {
      top: 20,
      right: 5,
      left: 5,
      bottom: 5
    }
  }, /*#__PURE__*/React.createElement(XAxis, {
    dataKey: "key",
    tickMargin: "15",
    tick: /*#__PURE__*/React.createElement(CustomizedTick, null)
  }), props.legend && /*#__PURE__*/React.createElement(Legend, {
    align: "center",
    verticalAlign: "bottom",
    height: 36,
    layout: "vertical",
    translation: translation ? translation.chart : null
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: "value.total",
    fill: "#33ff99",
    isAnimationActive: false
  }, props.label && /*#__PURE__*/React.createElement(LabelList, {
    position: "top",
    content: CustomizedLabel
  }), barData.map(function (entry, index) {
    return /*#__PURE__*/React.createElement(Cell, {
      key: "cell-".concat(index),
      fill: entry.value.type === "forecast" ? "transparent" : "#33ff99",
      stroke: entry.value.type === "forecast" ? "#33ff99" : "transparent",
      strokeWidth: entry.value.type === "forecast" ? "1" : "0",
      strokeDasharray: "5 5"
    });
  })), props.brush && /*#__PURE__*/React.createElement(Brush, {
    dataKey: "key",
    height: 10,
    tickFormatter: function tickFormatter(value) {
      return moment(value, "YYYYMM").format("MMMM YY");
    }
  })));
};

console.groupEnd();
export { SingleBarChart };